"use client";

// Libraries
import { Link, useRouter } from "@/i18n/navigation";
import Image from "next/image";

// Component
import Button from "@/components/ui/Button/Button";
import Footer from "@/components/ui/Footer/Footer";
import Slide from "@/components/ui/Slide/Slide";
import IntermediateLayout from "@/components/ui/Layout/IntermediateLayout/IntermediateLayout";
import InfoBadge from "@/components/ui/InfoBadge/InfoBadge";
import { useTranslations } from "next-intl";

export default function SerieComponent({ serie, locale }) {
    // Variables
    const t = useTranslations();
    const router = useRouter();

    let content = (
        <>
            <div className="min-h-screen dark">
                <div
                    className="flex flex-col z-10 relative w-full"
                    style={{
                        background: `url('${serie.image}') lightgray 50% / cover no-repeat`,
                        // height: "calc(100vh - 10vh)"
                    }}
                >
                    <div className="absolute top-0 left-0 right-0 bottom-0 flex flex-col bg-gradient-serie dark:bg-gradient-serie-dark"></div>
                    <div
                        className="bottom-0 left-0 opacity-75 absolute top-0 z-0"
                        style={{
                            background:
                                "linear-gradient(77deg,rgba(0,0,0,.7),transparent 95%)",
                            right: "0",
                        }}
                    ></div>
                    <div
                        className="min-h-full text-white z-30"
                        style={{ marginTop: "30vh" }}
                    >
                        <div className="lg:m-container m-containerMobile">
                            {serie.imageTitle ? (
                                <Image
                                    src={serie.imageTitle}
                                    alt="Logo"
                                    width={625 * 0.8}
                                    height={250 * 0.8}
                                    className="object-contain"
                                />
                            ) : (
                                <div
                                    className="2xl:text-5xl text-4xl bold xl:w-6/12 lg:w-9/12 w-full"
                                    style={{
                                        marginBottom: "1.2vw",
                                        textShadow:
                                            "2px 2px 4px rgba(0, 0, 0, .45)",
                                    }}
                                >
                                    {serie.title}
                                </div>
                            )}
                            <div className="text-lg font-bold">
                                {serie.isBelievemyOriginals &&
                                    "Believemy Originals・"}
                                {serie.seasons.length}{" "}
                                {serie.seasons.length > 1
                                    ? t("SerieModale_seasons").toLowerCase()
                                    : t("SerieModale_season").toLowerCase()}
                                ・{t("SerieModale_serie")}
                            </div>
                            <div
                                className="lg:w-144 w-full lg:text-xl text-lg mt-3"
                                style={{
                                    lineHeight: "135%",
                                    textShadow:
                                        "2px 2px 4px rgba(0, 0, 0, .45)",
                                }}
                            >
                                {serie.description}
                            </div>
                            {serie.language &&
                                serie.language.code != locale && (
                                    <div className="mt-3">
                                        <InfoBadge>
                                            {t("serie_language")}{" "}
                                        </InfoBadge>
                                    </div>
                                )}
                            {serie.seasons.length > 0 &&
                                serie.seasons[0].isOnline &&
                                serie.seasons[0].episodes &&
                                serie.seasons[0].episodes[0] &&
                                serie.seasons[0].episodes[0].isOnline && (
                                    <div className="flex items-center gap-4 mt-5">
                                        <Link
                                            href={`/series/${serie.slug}/1/1`}
                                        >
                                            <Button type="white">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="h-5 w-5 mr-3 text-excitationOrange"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        fill="currentColor"
                                                        d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.736 4 21.276 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648l12.812 6.968Z"
                                                    ></path>
                                                </svg>
                                                {t("SerieModale_watch")}
                                            </Button>
                                        </Link>
                                    </div>
                                )}
                        </div>
                        <div className="mt-32">
                            {serie.seasons.length > 0 &&
                            serie.seasons[0].isOnline &&
                            serie.seasons[0].episodes &&
                            serie.seasons[0].episodes[0] &&
                            serie.seasons[0].episodes[0].isOnline ? (
                                <div>
                                    {serie.seasons.map((season, index) => (
                                        <div key={`season-${index}`}>
                                            {season.isOnline &&
                                                season.episodes &&
                                                season.episodes[0] &&
                                                season.episodes[0].isOnline && (
                                                    <div
                                                        key={`season-${index}`}
                                                        className="text-black  dark:text-white"
                                                    >
                                                        <Slide
                                                            title={`${season.position}. ${season.title}`}
                                                            episodes={
                                                                season.episodes
                                                            }
                                                            type="episodes"
                                                            slug={serie.slug}
                                                            season={season}
                                                            showDetails
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="lg:m-container m-containerMobile text-white">
                                    {t("serie_noEpisodes")}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer withoutMarginTop />
        </>
    );

    // Rendu sans attendre la session : la page ne s'en sert pas, et Google
    // ne voyait qu'un spinner (« Soft 404 »).
    return content;
}
